import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const PAGE_SIZE_DEFAULT = 20;
const TOTAL_PAGE_DEFAULT = 2;

const propTypes = {
    onChangePage: PropTypes.func.isRequired,
    initialPage: PropTypes.number,
    pageSize: PropTypes.number,
    showPagination: PropTypes.bool,
    totalPages: PropTypes.number
}

const defaultProps = {
    initialPage: 1,
    pageSize: 20,
    showPagination: true,
    totalPages: 2
}


class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pager: {},
        };
    }

    UNSAFE_componentWillMount() {
        if (this.props.totalPages >= 0 && !this.state.check) {
            this.setState({
                totalPages: this.props.totalPages || TOTAL_PAGE_DEFAULT,
                pageSize: this.props.pageSize || PAGE_SIZE_DEFAULT,
                initialPage: this.props.initialPage || 1,
                showPagination: this.props.showPagination
            });
            let self = this;
            setTimeout(function () {
                self.setPage(self.state.initialPage);
            })
        }
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps.totalPages > 0 && !this.state.check) {
            this.setState({
                totalPages: nextProps.totalPages || TOTAL_PAGE_DEFAULT,
                pageSize: nextProps.pageSize || PAGE_SIZE_DEFAULT,
                initialPage: nextProps.initialPage,
                showPagination: nextProps.showPagination
            });
            let self = this;
            setTimeout(function () {
                self.setPage(self.state.initialPage);
            })
        }
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if (this.props.totalPages > 0) {
    //         this.setPage(this.props.initialPage);
    //     }
    // }

    setPage(page, check) {
        var { totalPages, pageSize, showPagination } = this.state;
        var pager = this.state.pager;
        if (page < 1 || page > pager.totalPages) {
            return;
        }
        pager = this.getPager(totalPages * pageSize, page, pageSize, showPagination);
        // var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);


        this.setState({ pager: pager });

        if (check) {
            this.setState({ check: check })
            let self = this;
            setTimeout(function () {
                self.setState({ check: false })
            }, 500)
            setTimeout(function () {
                self.props.onChangePage(page, check)
            })
        }
    }

    getPager(totalItems, currentPage, pageSize, showPagination) {
        currentPage = currentPage || 1;
        pageSize = pageSize || PAGE_SIZE_DEFAULT;
        var totalPages = Math.ceil(totalItems / pageSize);
        var startPage, endPage;
        if (totalPages <= 10) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
        var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages,
            showPagination: showPagination
        };
    }

    render() {
        var pager = this.state.pager;
        if (!pager.pages || pager.pages.length <= 1) {
            return null;
        }
        return (
            <nav>
                {pager.showPagination ?
                    <ul className="pagination">
                        <li className={`page-item ${pager.currentPage === 1 ? 'disabled' : ''}`} onClick={() => this.setPage(1, true)}>
                            <span className="page-link">最初へ</span>
                        </li>
                        <li className={`page-item ${pager.currentPage === 1 ? 'disabled' : ''}`} onClick={() => this.setPage(pager.currentPage - 1, true)}>
                            <span className="page-link">前へ</span>
                        </li>
                        {pager.pages.map((page, index) =>
                            <li key={index} className={pager.currentPage === page ? 'active' : ''} onClick={() => this.setPage(page, true)}>
                                <span className="page-link" >{page}</span>
                            </li>
                        )}
                        <li className={`page-item ${pager.currentPage === pager.totalPages ? 'disabled' : ''}`} onClick={() => this.setPage(pager.currentPage + 1, true)}>
                            <span className="page-link">次へ</span>
                        </li>
                        <li className={`page-item ${pager.currentPage === pager.totalPages ? 'disabled' : ''}`} onClick={() => this.setPage(pager.totalPages, true)}>
                            <span className="page-link">最後へ</span>
                        </li>
                    </ul> : ''
                }
            </nav>
        );
    }
}
Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
export default Pagination;